import React from 'react'
import AboutUsStartSection from '../components/aboutus/AboutUsStartSection'
import AboutUsSection from '../components/aboutus/AboutUsSection'
import PerfectHammock from '../components/home/PerfectHammock'
import StoryPerpose from '../components/aboutus/StoryPerpose'
import TransformHouse from '../components/aboutus/TransformHouse'
import HappyCustomer from '../components/home/HappyCustomer'
import NeedOfCustomDesign from '../components/home/NeedOfCustomDesign'
import FollowOnInstagram from '../components/home/FollowOnInstagram'

const AboutUs = () => {
  return (
    <>
      <AboutUsStartSection />
      <AboutUsSection background={false} />
      <PerfectHammock />
      <StoryPerpose />
      <TransformHouse />
      <HappyCustomer />
      <NeedOfCustomDesign />
      <FollowOnInstagram />
    </>
  )
}

export default AboutUs
